import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600RunChart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M331.97,168.27c-17.75,0-32.19,14.44-32.19,32.19c0,7.83,2.81,15.01,7.48,20.6l-10.49,15.22 c-3.28-1.13-6.79-1.75-10.45-1.75c-9.82,0-18.62,4.42-24.53,11.38l-16.33-7.51c0.26-1.66,0.41-3.36,0.41-5.09 c0-17.75-14.44-32.19-32.19-32.19s-32.19,14.44-32.19,32.19c0,7.83,2.81,15.01,7.48,20.6l-10.48,15.22 c-3.28-1.13-6.79-1.75-10.45-1.75c-17.75,0-32.19,14.44-32.19,32.19c0,17.75,14.44,32.19,32.19,32.19s32.19-14.44,32.19-32.19 c0-7.83-2.81-15.01-7.47-20.59l10.48-15.22c3.28,1.13,6.79,1.75,10.45,1.75c9.81,0,18.61-4.42,24.52-11.37l16.34,7.51 c-0.26,1.66-0.4,3.35-0.4,5.08c0,17.75,14.44,32.19,32.19,32.19s32.19-14.44,32.19-32.19c0-7.83-2.81-15.01-7.48-20.6l10.49-15.22 c3.28,1.13,6.79,1.75,10.45,1.75c17.75,0,32.19-14.44,32.19-32.19S349.71,168.27,331.97,168.27z M168.03,314.4 c-8.19,0-14.86-6.67-14.86-14.86s6.67-14.86,14.86-14.86c8.19,0,14.86,6.67,14.86,14.86S176.23,314.4,168.03,314.4z M213.68,248.16 c-8.19,0-14.86-6.67-14.86-14.86s6.67-14.86,14.86-14.86s14.86,6.67,14.86,14.86S221.87,248.16,213.68,248.16z M286.32,281.57 c-8.19,0-14.86-6.67-14.86-14.86s6.67-14.86,14.86-14.86s14.86,6.67,14.86,14.86S294.51,281.57,286.32,281.57z M331.97,215.32 c-8.19,0-14.86-6.67-14.86-14.86s6.67-14.86,14.86-14.86c8.19,0,14.86,6.67,14.86,14.86S340.16,215.32,331.97,215.32z"
	})]
});
const ForwardRef = forwardRef(SvgN600RunChart);
export { ForwardRef as ReactComponent };
